import { addResizeParamToURL } from '@/utils/cdn-utils';

export const useResizeImage = ({ source }: { source: string | undefined }): string | undefined =>
    source ? addResizeParamToURL(source, 256) : undefined;
